import React, { useState, useEffect } from 'react'
import { useParams  } from "react-router-dom"
import './common.css'
import API_URL from '../common/Apiurl';
import SuccessMessage from '../common/Message';

function Editwallet(){
    const apiUrl = API_URL;
    const [items, setItems]=useState('');
    const getParam = useParams();
    const getuserid = getParam.userid;
    const [successMessages, setSuccessMessages] = useState([]);
    const [notnumber, setNotnumber]=useState(true);

    useEffect(()=>{
        const getindustry = async (e) => {
            try{
                const postData = {
                    userId: getuserid
                };
                const result = await fetch(`${apiUrl}/admin/viewcoins`,{
                    method: "POST",
                    headers:{
                        "Content-Type":"application/json",
                        "Accept":"application/json"
                    },
                    body:JSON.stringify(postData)
                });
                const data = await result.json();
                if(data.status !== 200){
                    throw new Error('Data not found');
                }
                setItems(data.data);
            }
            catch(error){
                console.error('Error ', error)
            }
        };
        getindustry();
    }, []);

    const updatecoins = async(e) =>{
        e.preventDefault();
        if(notnumber == false){
            console.log('Not a number')
        }else{
            const coinsData = new FormData(e.target);
            const actionType = coinsData.get('coinstype');
            const coinsValue = coinsData.get('totalcoins');
            try{
                const postData={
                    userId:getuserid,
                    actionType:actionType,
                    coins:coinsValue
                }
                const result = await fetch(`${apiUrl}/admin/updatecoins`,{
                    method: "POST",
                    headers:{
                        "Content-Type":"application/json",
                        "Accept":"application/json"
                    },
                    body:JSON.stringify(postData) 
                });
                const data = await result.json();
                if((data.status == 200)){
                    const newSuccessMessage = data.message;
                    setSuccessMessages([...successMessages, newSuccessMessage]);
                }else if((data.status == 400)){
                    const newSuccessMessage = data.message;
                    setSuccessMessages([...successMessages, newSuccessMessage]);
                }
                if(data.status !== 200){
                    throw new Error('Data not found');
                }
                setItems(data.data);
            }
            catch(error){
                console.log('Error: ', error)
            }
        }
    }
    const coinvalue = (e) => {
        if(isNaN(e.target.value) === true){
            setNotnumber(false)
        }
        else{
            setNotnumber(true) 
        }
    }
    const handleSuccessMessageFadeOut = () =>{
        setSuccessMessages((prevMessages) => prevMessages.slice(1));
        window.location.reload();
    }
    return (
        <div className='width90'>
            <h2 className='pageTitle'>Edit Wallet</h2>
            <div className='commonCntr'>
                <form className="form-horizontal" onSubmit={updatecoins}>
                    <div className="form-group">
                        <label className="control-label col-sm-2 label" htmlFor="totalcoins">Total Credits:</label>
                        <span className='col-sm-4 d-inline-block'>{items.coins}</span>
                        <div className="col-sm-4">
                            <select className="form-select mt-4 mb-3" name="coinstype">
                                <option value="">Please select to add/delete Credits</option>
                                <option value="1">Add Credits</option>
                                <option value="2">Delete Credits</option>
                            </select>
                            <div className='col-sm-5'>
                                <input type="text" name="totalcoins" className="form-control" id="totalcoins" onChange={coinvalue}/>
                            </div>    
                            {notnumber?' ':'Please enter number only'}                        
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="col-sm-offset-2 col-sm-10">
                            <button type="submit" className="btn btn-default submitBtn">Submit</button>
                        </div>
                    </div>
                </form>
                {
                    successMessages.map((message, index) => (
                        <SuccessMessage
                            key={index} 
                            message = {message} 
                            onFadeOut={handleSuccessMessageFadeOut}
                        />
                    )
                )}
            </div>
        </div>
    )
}

export default Editwallet;